var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.108,26.085 C19.842,26.017 18.184,25.226 16.037,23.73 L15.997,23.703 L15.96,23.73 C13.813,25.227 12.156,26.018 10.888,26.086 L10.71,26.091 C7.963,26.091 7.613,23.451 8.992,18.847 L9.046,18.669 L8.946,18.594 C2.89,13.956 3.9,10.746 11.5,10.528 L11.702,10.523 L11.817,10.197 C13.001,6.867 14.243,5.112 15.844,5.005 L16,5 C17.674,5 18.957,6.76 20.182,10.197 L20.296,10.523 L20.5,10.528 C28.1,10.746 29.11,13.956 23.053,18.593 L22.951,18.668 L23.006,18.846 C24.356,23.358 24.046,25.983 21.45,26.086 L21.287,26.089 L21.108,26.085 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgStar);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/star.ba0957977a0aea87781791e2aa7046b4.svg";